/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axiosInstance from "../../libs/axios"

export default {
  SET_BEARER(state, accessToken) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  },
  SET_QR_CODE(state, qr_code) {
    state.qr_code = qr_code;
  },
  SET_VERIFIED(state, verified) {
    state.verified = verified
  },
  SET_POPUP_VISIBLE(state, visible) {
    state.popupVisible = visible
  },
  SET_USER(state, user) {
    state.cognitoUser = user
  },
}
